import React, { Component } from "react";
import Counter from "../Counter/Counter";
import { convertCurrency } from "../../utils";
import CartPopup from "../CartPopup/CartPopup"
import "./Cheque.scss";
import { config, PRODUCT_IDS, DEFAULT_CHEQUE_VALUES, CHEQUE_VALIDATION_RULES } from "../../Constants";

class Cheque extends Component {
  constructor(props) {
    super(props);
    const defaultValues = this.getDefaultChequeValues(props.product.id);
    this.state = {
      product: props.product,
      price: 0,
      couponValue: defaultValues.value,
      couponNumber: defaultValues.number,
      couponQuantity: defaultValues.quantity,
      couponName: "",
      open: false,
    };
  }

  getDefaultChequeValues(productId) {
    return DEFAULT_CHEQUE_VALUES[productId] || { value: 10, number: 20, quantity: 1 };
  }

  componentDidMount() {
    const { couponValue, couponNumber, couponQuantity, product } = this.state;
    
    // Handle price with safe calculations
    const totalPrice = (couponQuantity || 0) * (couponNumber || 0) * (couponValue || 0) + parseFloat(product.price || 0);
    this.setState({ price: totalPrice });
  }

  handleChange(e, isString = false) {
    if (!isNaN(parseInt(e.target.value)) || isString) {
      this.setState(
        {
          [e.target.name]: isString ? e.target.value : parseFloat(e.target.value) || 0,
        },
        () => {
          const { couponValue, couponNumber, couponQuantity, product } = this.state;
          const totalPrice = (couponQuantity || 0) * (couponNumber || 0) * (couponValue || 0) + parseFloat(product.price || 0);
          this.setState({ price: totalPrice });
        }
      );
    }
  }
  setOpen() {

    this.setState({open:!this.state.open})
  }

  addToCart() {
    const { product, couponName, couponNumber, couponQuantity, couponValue, price } = this.state;
   
    // Validate couponValue
    if (isNaN(couponValue) || couponValue <= 0) {
      alert("La valeur du chèque doit être un nombre valide supérieur à 0");
      return false;
    }
    
    // Get validation rules for the product
    const validationRules = CHEQUE_VALIDATION_RULES[product.id];
    
    if (!validationRules) {
      alert("Configuration de validation non trouvée pour ce produit");
      return false;
    }

    // Validate minimum couponValue
    if (couponValue < validationRules.minValue) {
      alert(`Le montant minimal de recharge de chèque ${product.name} est de : ${validationRules.minValue}TND`);
      return false;
    }

    // Validate maximum couponValue
    if (couponValue > validationRules.maxValue) {
      alert(`La valeur maximale du chèque est de ${validationRules.maxValue}TND`);
      return false;
    }

    // Validate couponNumber
    if (isNaN(couponNumber) || couponNumber < 1 || couponNumber > 1000) {
      alert("Le nombre de chèques par carnet doit être entre 1 et 1000");
      return false;
    }

    // Validate couponQuantity
    if (isNaN(couponQuantity) || couponQuantity < 1 || couponQuantity > 999) {
      alert("La quantité de carnets doit être entre 1 et 999");
      return false;
    }
    const addUrl =  document.getElementById("add-to-cart-or-refresh")?.value || `${config.url}/panier`;
    
    const token = (process.env.REACT_APP_STAGE==='dev')?"6201c3c0310244f2bcffdda74673397a":document.getElementsByName("token")[0].value;
  
    const data = new FormData();
    data.append("token", token);
    data.append("id_product", product.id);
    data.append("qty", couponQuantity);
    data.append("value", couponValue);
    data.append("number", couponNumber);
    data.append("name", couponName);
    data.append("total", price);
    data.append("add", 1);
    data.append("action", "update");

    const postToCart = async () => {
      const response = await fetch(addUrl, {
        method: "POST",
        mode: "cors",
        header: {
          headers: {
            'Accept': 'application/json, application/xml, text/plain, text/html, *.*'
          }
        },
        body: data,
      });
     return response;
    };
   
    
   postToCart().then( (resp)=>window.prestashop.emit('updateCart', {
      reason: {}, resp: resp,
    })).then(res=>this.setOpen()); 
 
  }

  render() {
    const { open, product, price, couponValue, couponNumber, couponQuantity } = this.state;
    
    // Get validation rules for the product
    const validationRules = CHEQUE_VALIDATION_RULES[product.id] || { minValue: 10, maxValue: 9999 };
    const minValue = validationRules.minValue;
    const maxValue = validationRules.maxValue;
    return (
      <div className="Cheque">
        <h1>{product.name}</h1>
        <p style={{textAlign: "justify"}}>{product.description_short.replace(/<[^>]*>?/gm, '')}</p>
        <p style={{ color: "#C9383F"}}>{convertCurrency(price)}</p>
        <div className="form">
        <div style={{justifyContent: "space-between"}}className="input-group">
          <div className="label">
            <label htmlFor="couponValue">Valeur de chèque :</label>
          </div>
          <Counter
            name="couponValue"
            value={couponValue}
            min={minValue}
            max={maxValue}
            step={0.5}
            stepInput={1}
            onValueChange={(e) => this.handleChange(e)}
          />
        </div>
        <div style={{justifyContent: "space-between"}} className="input-group">
          <div style={{textAlign: "justify"}} className="label">
            <label htmlFor="couponNumber">Nombre de chèque par carnet :</label>
          </div>
          <Counter
            name="couponNumber"
            value={couponNumber}
            min={1}
            max={Infinity}
            step={1}
            stepInput={1}
            onValueChange={(e) => this.handleChange(e)}
          />
        </div>
        <div style={{justifyContent: "space-between"}} className="input-group">
          <div className="label">
            <label htmlFor="couponQuantity">Quantité de carnets:</label>
          </div>
          <Counter
            name="couponQuantity"
            value={couponQuantity}
            min={1}
            max={999}
            step={1}
            stepInput={1}
            onValueChange={(e) => this.handleChange(e)}
          />
        </div>
        <div style={{justifyContent: "space-between"}} className="input-group">
          <div style={{textAlign: "initial"}} className="label">
            <label htmlFor="couponName">Message personnalisé :</label>
          </div>
          <input
            className="text-input"
            name="couponName"
            maxLength="100"
            value={this.state.couponName}
            onChange={(e) => this.handleChange(e, true)}
          />
        </div>
        </div>
        <div className="product-add-to-cart">
          <div className="add green_btn">
            <button type="submit" onClick={()=>this.addToCart()}>
              Commander
      </button>
          </div>
        </div>
        <CartPopup Produit={this.state.product} Price={this.state.price} Quantity={this.state.couponQuantity} setOpen={()=>this.setOpen()} open={open} />
      </div>
    );
  }
}

export default Cheque;
